import {Component, OnInit, inject} from '@angular/core';
import {ClientService} from '../../../client/client.service';
import {Observable, of, Subject} from 'rxjs';
import {Client} from '../../../client/client';
import {filter, mergeMap, tap} from 'rxjs/operators';
import {ThuisverzorgerService} from '../../../thuisverzorger/thuisverzorger.service';
import {Router} from '@angular/router';
import {PrestatieService} from '../../../prestatie/prestatie.service';
import {DialogService} from '../../../core/dialog/dialog.service';
import {Thuisverzorger} from '../../../thuisverzorger/thuisverzorger';
import {Clientnummer} from '../../../client/clientnummer-selector/clientnummer';
import {Diensten} from '../../../dienst/diensten';
import {DienstService} from '../../../dienst/dienst.service';
import * as lodash from 'lodash';

@Component({
  templateUrl: './start-prestatie.page.html',
  styleUrls: ['./start-prestatie.page.scss'],
  standalone: false
})
export class StartPrestatiePage implements OnInit {
  private thuisverzorgerService = inject(ThuisverzorgerService);
  private dienstService = inject(DienstService);
  private clientService = inject(ClientService);
  private prestatieService = inject(PrestatieService);
  private dialogService = inject(DialogService);
  private router = inject(Router);

  thuisverzorger$: Observable<Thuisverzorger> = new Observable<Thuisverzorger>();
  diensten$: Observable<Diensten> = new Observable<Diensten>();
  client$: Subject<Client> = new Subject<Client>();

  searchEnabled = true;
  searchingClientficheEnabled = false;
  prestatieStarted = false;
  clientnummer: Clientnummer;

  ngOnInit(): void {
    this.thuisverzorger$ = this.thuisverzorgerService.getThuisverzorgerMe$();
    this.diensten$ = this.dienstService.getDiensten$();
  }

  onClientNummerSelected(clientnummer: Clientnummer): void {
    this.clientnummer = clientnummer;
    this.client$.next(null);
    this.clientService.getClientByNummer$(clientnummer.nummer)
      .pipe(tap(() => this.searchEnabled = false))
      .subscribe(client => this.client$.next(client));
  }

  onClientNummerForClientFicheSelected(clientnummer: string): void {
    this.client$.next(null);
    this.clientService.getClientByNummer$(clientnummer)
      .pipe(tap(() => this.searchEnabled = false))
      .subscribe(client => this.client$.next(client));
  }

  startPrestatie(client: Client, thuisverzorger: Thuisverzorger, diensten: Diensten): void {
    this.prestatieStarted = true;
    if (diensten.filterForThuisverzorgerAtClient(thuisverzorger, client).isEmpty()) {
      this.prestatieStarted = false;
      this.dialogService.showInformation('Er zijn geen diensten voor deze cliënt. Contacteer je dienst.');
    } else {
      this.getZoneConfirmation(thuisverzorger, client).pipe(
        tap(confirmation => {
          if (!confirmation) {
            this.prestatieStarted = false;
          }
        }),
        filter(confirmation => confirmation),
        mergeMap(() => this.prestatieService.startPrestatie$(client.getId(), this.clientnummer.zoekMethode)),
      ).subscribe(prestatie => this.router.navigateByUrl(`/prestatie/${prestatie.getId()}/diensten`));
    }
  }

  navigateToClientFiche(client: Client) {
    this.router.navigate([`/clienten/${client.getId()}/fiche`]);
  }

  protected navigateToClientMeldingen(client: Client) {
    this.router.navigate([`/clienten/${client.getId()}/meldingen`]);

  }

  private getZoneConfirmation(thuisverzorger: Thuisverzorger, client: Client): Observable<boolean> {
    if (lodash.intersection(thuisverzorger.getUniqueZoneIds(), client.getUniqueZoneIds()).length > 0) {
      return of(true);
    } else {
      return this.dialogService.askConfirmation({
        message: '<div>Deze cliënt woont niet in de regio waarin jij werkt.</div><div>Ben je zeker dat je de prestatie wil opstarten?</div>'
      });
    }
  }

  isSearchEnabled(): boolean {
    return this.searchEnabled;
  }

  enableSearch(): void {
    this.client$.next(null);
    this.searchEnabled = true;
  }

  isSearchingClientficheOrMeldingenEnabled(): boolean {
    return this.searchingClientficheEnabled;
  }

  searchForClientfiche() {
    this.searchingClientficheEnabled = true
  }

  searchForClientToStartPrestatie() {
    this.searchingClientficheEnabled = false
  }
}
